// extracted by mini-css-extract-plugin
export var askAiIcon = "_lg-9";
export var container = "_lg-0";
export var groupSeparator = "_lg-a";
export var highlight = "_lg-4";
export var resultIcon = "_lg-5";
export var resultItem = "_lg-7";
export var resultSubtitle = "_lg-3";
export var resultTitle = "_lg-2";
export var resultsList = "_lg-1";
export var searchGroup = "_lg-6";
export var selected = "_lg-8";